<template>
    <form @submit.prevent="handleSubmit(item)">

        <div :class="{ 'form-group': true, 'has-error': (errors && errors.name) }">
            <label for="_name" class="control-label">Name</label>
            <input v-model="item.name" type="text" placeholder="the name of the cookie" required="true" id="_name"
                   class="form-control"/>
            <span v-if="errors && errors.name" class="help-block" id="_name_helpBlock">{{ errors.name }}</span>
        </div>
        <div :class="{ 'form-group': true, 'has-error': (errors && errors.origin) }">
            <label for="_origin" class="control-label">Origin</label>
            <input v-model="item.origin" type="text" placeholder="origin of the cookie" id="_origin"
                   class="form-control"/>
            <span v-if="errors && errors.origin" class="help-block" id="_origin_helpBlock">{{ errors.origin }}</span>
        </div>
        <div :class="{ 'form-group': true, 'has-error': (errors && errors.type) }">
            <label for="_type" class="control-label">Type</label>
            <select v-model="item.type" type="text"
                   placeholder="type of the cookie ('Not defined', 'Technical', 'Profiling' or '3rd party')" id="_type"
                    class="form-control">
                <option>Not defined</option>
                <option>Technical</option>
                <option>Profiling</option>
                <option>3rd party</option>
            </select>
            <span v-if="errors && errors.type" class="help-block" id="_type_helpBlock">{{ errors.type }}</span>
        </div>
        <div :class="{ 'form-group': true, 'has-error': (errors && errors.duration) }">
            <label for="_duration" class="control-label">Duration</label>
            <input v-model="item.duration" type="number" placeholder="" id="_duration" class="form-control"/>
            <span v-if="errors && errors.duration" class="help-block"
                  id="_duration_helpBlock">{{ errors.duration }}</span>
        </div>
        <div :class="{ 'form-group': true, 'has-error': (errors && errors.durationUnit) }">
            <label for="_durationUnit" class="control-label">Duration Unit</label>
            <select v-model="item.durationUnit" type="text"
                   placeholder="duration unit of the cookie (Permanent, Session, Seconds, Minutes, Hours, Days, Months, Years)"
                    id="_durationUnit" class="form-control">
                <option>Permanent</option>
                <option>Session</option>
                <option>Seconds</option>
                <option>Minutes</option>
                <option>Hours</option>
                <option>Days</option>
                <option>Months</option>
                <option>Years</option>
            </select>
            <span v-if="errors && errors.durationUnit" class="help-block" id="_durationUnit_helpBlock">{{ errors.durationUnit }}</span>
        </div>
        <div class="card bn-tabs">
            <ul class="nav nav-tabs" id="myTab" role="tablist">
                <li v-for="(value, key, index) in languages" class="nav-item" >
                    <a class="nav-link" v-bind:class="{ active: index===0, show: index===0 }" :id="'translation-tab-' + key" data-toggle="tab"
                       :href="'#translation-tab-content-' + key" role="tab" :aria-controls="index" aria-selected="false">{{
                        value }}</a>
                </li>
            </ul>
            <div class="tab-content" id="translationTabContent">
                <div v-for="(value, key) in item.translations" class="tab-pane fade"
                     v-bind:class="{ active: key==='de', show: key==='de' }" :id="'translation-tab-content-' + key"
                     role="tabpanel" :aria-labelledby="'translation-tab-' + key">
                    <div :class="{ 'form-group': true, 'has-error': (errors && errors.translations && errors.translations.description) }">
                        <label :for="'_translation_'+ key +'_description'" class="control-label">Description</label>
                        <textarea v-model="item.translations[key].description"
                               placeholder="a description of the cookie"
                                  :id="'_translation_'+ key +'_description'" class="form-control"></textarea>
                        <span v-if="errors && errors.translations && errors.description" class="help-block"
                              :id="'_translation_'+ key +'_description_helpBlock'">{{ errors.translations[key].description }}</span>
                    </div>
                    <div :class="{ 'form-group': true, 'has-error': (errors && errors.url) }">
                        <label :for="'_translation_'+ key +'_url'" class="control-label">URL</label>
                        <input v-model="item.translations[key].url" type="text"
                               placeholder="URL of the cookie" id="_url"
                               class="form-control"/>
                        <span v-if="errors && errors.url" class="help-block"
                              :id="'_translation_'+ key +'_url_helpBlock'">{{ errors.url }}</span>
                    </div>
                    <div :class="{ 'form-group': true, 'has-error': (errors && errors.optOutUrl) }">
                        <label :for="'_translation_'+ key +'_optOutUrl'" class="control-label">Opt Out URL</label>
                        <input v-model="item.translations[key].optOutUrl" type="text" placeholder="Opt-Out-URL of the cookie"
                               :id="'_translation_'+ key +'_optOutUrl'" class="form-control"/>
                        <span v-if="errors && errors.optOutUrl" class="help-block"
                              :id="'_translation_'+ key +'_optOutUrl_helpBlock'">{{ errors.optOutUrl }}</span>
                    </div>

                    <div :class="{ 'form-group': true, 'has-error': (errors && errors.locale) }">
                        <input vmodel="item.translations[key].locale" type="hidden"
                               :id="'_translation_'+ key +'_locale'" class="form-control"/>
                        <input vmodel="item.translations[key].id" type="hidden" :id="'_translation_'+ key +'_id'"
                               class="form-control"/>
                        <span v-if="errors && errors.locale" class="help-block"
                              :id="'_translation_'+ key +'_locale_helpBlock'">{{ errors.locale }}</span>
                    </div>
                </div>
            </div>

        </div>


        <button type="submit" class="btn btn-primary">Submit</button>
    </form>
</template>

<script>
    import {API_LANGUAGES} from '../../config/languages';

    export default {
        props: {
            handleSubmit: {
                type: Function,
                required: true,
            },
            values: {
                type: Object,
                required: true
            },
            errors: {
                type: Object
            },
            initialValues: {
                type: Object
            }
        },
        computed: {
            item: function () {
                let values=this.initialValues ? this.initialValues : this.values;
                let newtranslations={};
                let translations = values.translations;
                Object.keys(API_LANGUAGES).map(function(objectKey, index) {
                    let value = API_LANGUAGES[objectKey];
                    let translation={
                        "@id":null,
                        description:"",
                        url:"",
                        optOutUrl:"",
                        locale:objectKey,
                    }
                    if (values.translations) {

                        for (let index in translations) {
                            let val = translations[index];
                            if (val.locale===objectKey){
                                translation=val;
                            }
                        }
                    }
                    newtranslations[objectKey]=translation;
                });
                values.translations=newtranslations;
                return values;
            }
        },
        data: function () {
            return {
                languages: API_LANGUAGES
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/cookie/Form.vue